module.exports = __webpack_public_path__ + "static/media/twitter-bg.e71027d1.svg";